module.exports = __webpack_public_path__ + "img/buy.1e29448d.jpg";